<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('payrolls')" :icon="'grid'" />
            </div>
            <div 
                class="col-sm-12 col-md-6 breadcrumb-side-button"
                v-if="this.$can('store_payrolls')"
            >
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal"
                        @click="openAddEditModal">
                        {{ this.$t('add') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <payroll-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="payroll-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import AppFunction from '../../../../core/helpers/app/AppFunction';
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { status } from '../../../Mixins/FilterMixin';

export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppPayrolls",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'payrolls-table',
            rowData: {},
            options: {
                name: 'AppPayrolls',
                url: actions.PAYROLL,
                showHeader: true,
                enableHighlights: true,
                enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t(''),
                        type: 'media-object',
                        key: 'employee',
                        mediaTitleKey: '',
                        mediaSubtitleKey: '',
                        default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
                        modifier: (value, row) => {
                            return value.photo; // imag url
                        },
                    },
                    {
                        title: this.$t('employee'),
                        type: 'object',
                        key: 'employee',
                        modifier: (employee => {
                            return employee ? `${employee.last_name} ${employee.middle_name} ${employee.first_name}` : '-';
                        })
                    },
                    {
                        title: this.$t('payroll_period'),
                        type: 'object',
                        key: 'period',
                        modifier: (period => period.name ? period.name : '-')
                    },
                    {
                        title: this.$t('currency'),
                        type: 'text',
                        key: 'currency',
                    },
                    {
                        title: this.$t('base_salary'),
                        type: 'text',
                        key: 'base_salary',
                    },
                    {
                        title: this.$t('cnss'),
                        type: 'text',
                        key: 'cnss_employee',
                    },
                    {
                        title: this.$t('ipr_due_usd'),
                        type: 'text',
                        key: 'ipr_due_usd',
                    },
                    {
                        title: this.$t('gross_salary'),
                        type: 'text',
                        key: 'gross_salary',
                    },
                    {
                        title: this.$t('net_salary'),
                        type: 'text',
                        key: 'net_salary',
                    },

                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
						title: this.$t('view'),
                        icon: 'printer',
						type: 'download',
						modifier: () => this.$can("payslip_download"),
					},
                    // {
                    //     title: this.$t('edit'),
                    //     icon: 'edit',
                    //     type: 'none',
                    //     component: 'payroll-add-modal',
                    //     modalId: 'payroll-add-edit-modal',
                    //     modifier: () => this.$can('update_payrolls'),

                    // },
                    // {
                    //     title: this.$t('delete'),
                    //     icon: 'trash',
                    //     type: 'none',
                    //     component: 'app-confirmation-modal',
                    //     modalId: 'user-delete',
                    //     modifier: () => this.$can('delete_payrolls'),
                    // }
                ],
                filters: [
                    {
                        "title": this.$t('created_at'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                ],
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal 
         */
        closeAddEditModal() {
            $("#payroll-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.openDeleteModal();
            } else if (actionObj.type === 'download') {
				window.open(AppFunction.getAppUrl(`payslip-download/${rowData.id}`))
			} else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.PAYROLL}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.PAYROLL}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#payroll-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
